
const FBODirectoryFuelTableRow = (props) => {
    return (
        <div className={'fuel-row' + (props.IsLabelRow ? ' fuel-labels' : '')}>
            <div className='fuel-detail'>
                {props.Type}
            </div>
            <div className='fuel-detail'>
                {props.Brand}
            </div>
            <div className='fuel-detail'>
                {props.Price}
            </div>
        </div>
    );
};

export default FBODirectoryFuelTableRow;